import axios from 'axios';

class ImpressaoServices {
    constructor() {
        this.api = axios.create({
            baseURL: process.env.VUE_APP_API_DRIVER_IMPRESSAO_URL,
            timeout: +process.env.VUE_APP_REQUEST_TIMEOUT * 1000,
        });

        this.api.interceptors.request.use((config) => {
            const token = localStorage.getItem('jwtToken');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        }, (error) => {
            return Promise.reject(error);
        });

        this.api.interceptors.response.use(
            (response) => response.data,
            (error) => {
                return Promise.reject(error);
            }
        );
    }

    imprimirEtiqueta(etiqueta, nomeImpressora, computador_impressora, qtdRepetir = 1) {
        return this.api.post('/imprimir', 
            { etiqueta,  contagem_repeticoes: qtdRepetir },
            {
                params: {
                    nome_impressora: nomeImpressora,
                    computador_impressora: computador_impressora
                }
            }
        )
        .then(response => response.data)
        .catch(error => {
            console.error("Erro ao imprimir:", error.response?.data);
            throw error;
        });
    }

    buscarHostname() {
        return this.api.get('/computador', {
            params: {}
        })
        .then(response => response)
        .catch(error => {
            console.error("Erro ao imprimir a etiqueta:", error);
            return Promise.reject(error);
        });
    }
    
}

export default new ImpressaoServices();
